import { z } from 'zod';

export const dacPreCreateDraftValidationSchema = () => {
  return z.object({
    appelOffreId: z.number({ required_error: 'Le champ appelOffreId est obligatoire' }).min(1, 'Le champ appelOffreId doit être présent'),
    dynaDocsModelId: z
      .number({ required_error: 'Le champ dynaDocsModelId est obligatoire' })
      .min(1, 'Le champ dynaDocsModelId doit être supérieur à 0'),
  });
};

export const dacUpdateDraftValidationSchema = () => {
  return z.object({
    responsableDacId: z
      .string({ required_error: 'Le champ responsable est obligatoire', invalid_type_error: 'Le champ responsable est obligatoire' })
      .min(1, 'Le champ responsable doit être présent'),
  });
};

export const dacUpdateConfigValidationSchema = () => {
  return z.object({
    scenarioId: z
      .number({ required_error: 'Le champ scénario est obligatoire', invalid_type_error: 'Le champ scénario est obligatoire' })
      .min(1, 'Le champ scénario doit être présent'),
    // dacDocSoumissionCreateRequests: z.array(
    //   z.object({
    //     docTypeId: z
    //       .number({ required_error: 'Le champ type de document est obligatoire', invalid_type_error: 'Le champ type de document est obligatoire' })
    //       .min(1, 'Le champ type de document doit être présent'),
    //     libelle: z
    //       .string({ required_error: 'Le champ libellé est obligatoire', invalid_type_error: 'Le champ libellé est obligatoire' })
    //       .min(1, 'Le champ libellé doit être présent'),
    //   }),
    //   { required_error: 'Le champ documents de soumission est obligatoire', invalid_type_error: 'Le champ documents de soumission est obligatoire' }
    // ),
  });
};
